import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34fb75d6")

_pushScopeId("data-v-34fb75d6")
const _hoisted_1 = { class: "radar-chart-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "chart-container" }, [
  /*#__PURE__*/_createVNode("div", { class: "chart-wrapper" }, [
    /*#__PURE__*/_createVNode("div", { id: "radar-chart" })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})